<template lang="pug">
  section
    b-container
      h1.mt-0(v-if="orderLine") Return an item
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'Orders'}")
          font-awesome-icon.mr-2(icon="chevron-left")
          span Back to Orders
      h4 Return details
      content-loader(:height="7", v-if="alert.loading")
      b-card(v-else-if="orderLine")
        .container
          h6.mb-2 Return
          ul.list-unstyled
              li
                span.font-weight-bold Piece
                span.ml-1 {{ orderLine.product_title }}
              li
                span.font-weight-bold Amount
                span.ml-1 {{ formatRandsCents(orderLine.line_total) }}
          b-form(@submit.prevent="returnItem()")
            b-form-group
              label Reason for return
                b-form-select(:options="return_reasons", text-field="title", value-field="id", v-model="inputForm.reason_id", required)
            .text-right
              button-load(type="submit", :flag="alert.busy", label="Submit", classes="btn-outline")
</template>

<script>

import { mapState } from 'vuex';
import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import router from '@/router';

export default {
  name: 'Order',
  mixins: [standardMix],
  data() {
    return {
      orderLine: null,
      inputForm: {
        customer_order_line_id: '',
        reason: '',
      },
    };
  },
  computed: {
    ...mapState('resource', ['return_reasons']),
  },
  methods: {
    async returnItem() {
      try {
        this.busy();
        await apiService.addReturn(this.inputForm);
        this.success('Return processed');
        router.push({ name: 'Orders' });
      } catch (error) {
        this.error('Could not process return');
      }
    },
  },
  async created() {
    if (this.$route.params.customerOrderLineId) {
      this.inputForm.customer_order_line_id = this.$route.params.customerOrderLineId;
      this.loading();
      this.orderLine = await apiService.getOrderLine(this.$route.params.customerOrderLineId);
      this.clear();
    } else {
      router.push({ name: 'Orders' });
      this.error('Item not specified');
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Return.vue